import React from 'react';
import { normalizeCrmLeadStatus } from '../../services/crmService';
import { leadWorkflowBadgeClass } from '../../utils/statusStyles';

interface LeadStatusBadgeProps {
  status: string;
  converted?: boolean;
}

export const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({ status, converted }) => {
  const key = normalizeCrmLeadStatus(status);
  return (
    <span className={leadWorkflowBadgeClass(key, { converted })}>
      {converted ? 'Converted' : LEAD_LABEL[key] ?? key}
    </span>
  );
};

const LEAD_LABEL: Record<string, string> = {
  new: 'New',
  attempted: 'Attempted',
  contacted: 'Contacted',
  replied: 'Replied',
  qualified: 'Qualified',
  unqualified: 'Unqualified',
};
